import { render, staticRenderFns } from "./UniLoginSolid.vue?vue&type=template&id=92f4b28c&scoped=true&"
import script from "./UniLoginSolid.vue?vue&type=script&lang=js&"
export * from "./UniLoginSolid.vue?vue&type=script&lang=js&"
import style0 from "./UniLoginSolid.vue?vue&type=style&index=0&id=92f4b28c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f4b28c",
  null
  
)

export default component.exports